import Vue from 'vue';
import iView from 'iview';
import VueRouter from 'vue-router';
import Routers from './router';
import Util from './libs/util';
import AjaxPlugin from './libs/AjaxPlugin';
import Default from './layouts/Default';
import Plain from './layouts/Plain';
import App from './app.vue';
import store from './store'
// import Header from './components/Header'
import 'iview/dist/styles/iview.css';

Vue.config.productionTip = false


Vue.use(AjaxPlugin);
Vue.use(VueRouter);
Vue.use(iView);
// Vue.prototype.$Header = Header;
Vue.component('default-layout', Default);
Vue.component('plain-layout', Plain);


// 路由配置
const RouterConfig = {
  mode: 'hash',
  routes: Routers
};
const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  Util.title(to.meta.title);
  next();
});

router.afterEach(() => {
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});

const BASE_URL = process.env.BASE_URL;
Vue.http.defaults.baseURL = BASE_URL;
Vue.http.interceptors.request.use((config) => {
  // continue to next interceptor
  let token = localStorage.getItem("tk");
  if (token) {
    config.headers.common["Authorization"] = token;
  }
  return config;
});

let showingToast = false;
Vue.http.interceptors.response.use((resp) => {
  if (resp.data.status != 1) { // 统一在此处理非200的异常
    Vue.prototype.$Message.error(resp.data.data);
    return {};
  }
  return resp.data;
}, (error) => {
  let resp = error.response;
  if (resp.status == 401) {
    router.push('/login');
  } else if (resp.status == 400) {
    let div = document.createElement("div")
    div.innerHTML = resp.config.url;
    document.body.appendChild(div);
  } else if (resp.status == 405) {
    Vue.prototype.$Message.error("方法不支持");
  } else if (resp.status >= 500) {
    Vue.prototype.$Message.error("服务器异常，请联系客服");
  }
  return {};
});

new Vue({
  el: '#app',
  router: router,
  store: store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js